import axios from 'axios';
import * as types from './actionTypes';
import * as urls from './urlTypes';

// Thunks - actions that return a function that accepts a dispatch
export const updateTreeLoad = node => ({
  type: types.UPDATE_DICTIONARY_TREE_LOAD,
  node,
});

export const clearTreeLoadNodeList = childNodeFlag => ({
  type: types.CLEAR_TREE_LOAD_NODE_LIST,
  childNodeFlag,
});

export const clearTreeNodes = () => ({
  type: types.CLEAR_TREE_NODE,
});

export const dictionaryTargetLoadFromSearch = node => ({
  type: types.GET_DICTIONARY_TARGET_LOAD_FROM_SEARCH,
  payload: node,
});

export const setDataPointAlreadyAdded = isDataAdded => ({
  type: types.SET_DATAPOINTS_ALREADY_ADDED,
  payload: isDataAdded,
});

export const dictionaryTargetReset = () => ({
  type: types.RESET_DICTIONARY_TARGET,
});

// Thunks - actions that return a function that accepts a dispatch
export function getDictionaryTreeLoad(
  token,
  uid,
  accountId,
  productNo,
  nodeID,
  filter
) {
  const url = `${urls.ROOT_URL}/dictionary/treeloadex`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data: {
        uid,
        accountId,
        productNo,
        node: nodeID,
        filter,
      },
    })
      .then(response =>
        dispatch({
          type: types.GET_DICTIONARY_TREE_LOAD,
          payload: response.data,
          nodeID,
        }),
      )
      .catch(response => console.warn(response.data));
  };
}

export function searchDictionaryTree(
  token,
  uid,
  accountId,
  productNo,
  searchType,
  searchText,
) {
  const url = `${urls.ROOT_URL}/dictionary/search`;
  return dispatch => {
    const nodeID = 0;
    axios({
      url,
      method: 'post',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      data: {
        uid: `${uid}`,
        accountId: `${accountId}`,
        productNo: `${productNo}`,
        searchType: `${searchType}`,
        searchText: `${searchText}`,
      },
      withCredentials: true,
      responseType: 'json',
    })
      .then(response =>
        dispatch({
          type: types.SEARCH_DICTIONARY_TREE_LOAD,
          payload: response.data,
          nodeID,
        }),
      )
      .catch(response => console.warn(response.data));
  };
}

// Thunks - actions that return a function that accepts a dispatch
export function getDictionaryTargetLoad(
  token,
  uid,
  accountId,
  productNo,
  nodeID,
  filter,
  selectedNode,
  useQuestions,
  componentGridCategory,
  isTargetAnswer,
) {
  const url = `${urls.ROOT_URL}/dictionary/treeloadex`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data: {
        uid,
        accountId,
        productNo,
        node: nodeID,
        filter,
      },
    })
      .then(response =>
        dispatch({
          type: types.GET_DICTIONARY_TARGET_LOAD,
          payload: response.data,
          nodeID,
          selectedNode,
          useQuestions,
          componentGridCategory,
          isTargetAnswer,
        }),
      )
      .catch(response => console.warn(response.data));
  };
}

export function getSampleWeighted({
  sourceGrid,
  targetGrid,
  uid,
  accountId,
  productNo,
  weightType,
  divisor,
  expressionList,
  selectedNames,
  gridData,
  recTypes,
  titlePrefix,
  originalNames,
  objSmartSearchArray,
  isLabelUpdated,
  oldProductNo,
  userDefinedText,
  weightChange,
}) {
  userDefinedText = userDefinedText || false;
  const url = `${urls.ROOT_URL}/crosstab/samplewgtd`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 202,
      data: {
        uid,
        accountId,
        productNo,
        weightType,
        divisor,
        expressionList,
      },
    })
      .then(response => {
        dispatch({
          type: types.FUNCTION_SAMPLE_WEIGHTED,
          payload: response.data.data,
          gridData,
          sourceGrid,
          targetGrid,
          selectedNames,
          expressionList,
          recTypes,
          titlePrefix,
          originalNames,
          objSmartSearchArray,
          isLabelUpdated,
          productNo,
          oldProductNo,
          userDefinedText,
          weightChange,
        });
      })
      .catch(response => console.warn(response));
  };
}
export const clearSampleWeighted = targetGrid => ({
  type: types.CLEAR_DICTIONARY_SAMPLE_WEIGHTED,
  targetGrid,
});
